/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FamilyPoolInvitation
 */
export interface FamilyPoolInvitation {
    /**
     * 
     * @type {string}
     * @memberof FamilyPoolInvitation
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FamilyPoolInvitation
     */
    inviteeEmail: string;
    /**
     * 
     * @type {string}
     * @memberof FamilyPoolInvitation
     */
    status: FamilyPoolInvitationStatusEnum;
    /**
     * Name of the user who sent the invitation
     * @type {string}
     * @memberof FamilyPoolInvitation
     */
    inviterName: string;
    /**
     * Name of the invitee (null if not yet on Gondola)
     * @type {string}
     * @memberof FamilyPoolInvitation
     */
    inviteeName?: string | null;
    /**
     * True if the current user sent this invitation
     * @type {boolean}
     * @memberof FamilyPoolInvitation
     */
    isSentByCurrentUser: boolean;
    /**
     * Token for new-user signup link (only visible to inviter)
     * @type {string}
     * @memberof FamilyPoolInvitation
     */
    inviteToken?: string | null;
    /**
     * Expiry time for new-user invites
     * @type {Date}
     * @memberof FamilyPoolInvitation
     */
    expiresAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof FamilyPoolInvitation
     */
    createdAt: Date;
}


/**
 * @export
 */
export const FamilyPoolInvitationStatusEnum = {
    Pending: 'pending',
    Accepted: 'accepted',
    Declined: 'declined',
    Revoked: 'revoked',
    Expired: 'expired'
} as const;
export type FamilyPoolInvitationStatusEnum = typeof FamilyPoolInvitationStatusEnum[keyof typeof FamilyPoolInvitationStatusEnum];


/**
 * Check if a given object implements the FamilyPoolInvitation interface.
 */
export function instanceOfFamilyPoolInvitation(value: object): value is FamilyPoolInvitation {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('inviteeEmail' in value) || value['inviteeEmail'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('inviterName' in value) || value['inviterName'] === undefined) return false;
    if (!('isSentByCurrentUser' in value) || value['isSentByCurrentUser'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function FamilyPoolInvitationFromJSON(json: any): FamilyPoolInvitation {
    return FamilyPoolInvitationFromJSONTyped(json, false);
}

export function FamilyPoolInvitationFromJSONTyped(json: any, ignoreDiscriminator: boolean): FamilyPoolInvitation {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'inviteeEmail': json['invitee_email'],
        'status': json['status'],
        'inviterName': json['inviter_name'],
        'inviteeName': json['invitee_name'] == null ? undefined : json['invitee_name'],
        'isSentByCurrentUser': json['is_sent_by_current_user'],
        'inviteToken': json['invite_token'] == null ? undefined : json['invite_token'],
        'expiresAt': json['expires_at'] == null ? undefined : (new Date(json['expires_at'])),
        'createdAt': (new Date(json['created_at'])),
    };
}

export function FamilyPoolInvitationToJSON(json: any): FamilyPoolInvitation {
    return FamilyPoolInvitationToJSONTyped(json, false);
}

export function FamilyPoolInvitationToJSONTyped(value?: FamilyPoolInvitation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'invitee_email': value['inviteeEmail'],
        'status': value['status'],
        'inviter_name': value['inviterName'],
        'invitee_name': value['inviteeName'],
        'is_sent_by_current_user': value['isSentByCurrentUser'],
        'invite_token': value['inviteToken'],
        'expires_at': value['expiresAt'] == null ? value['expiresAt'] : value['expiresAt'].toISOString(),
        'created_at': value['createdAt'].toISOString(),
    };
}

